import { render, staticRenderFns } from "./MemberOrderLogistics.vue?vue&type=template&id=643d4c40&scoped=true&"
import script from "./MemberOrderLogistics.vue?vue&type=script&lang=js&"
export * from "./MemberOrderLogistics.vue?vue&type=script&lang=js&"
import style0 from "./MemberOrderLogistics.vue?vue&type=style&index=0&id=643d4c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d4c40",
  null
  
)

export default component.exports